import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export type getGeocodingConfigsRequestConfigParams = {
  readonly datasourceLuid: string;
}
export type addUpdateGeocodingConfigsRequestConfigParams = {
  readonly configId?: string;
  readonly datasourceLuid: string;
  readonly configName: string;
  readonly colName: string;
  readonly tokenLimit: number;
}

export function getGeocodingConfigsRequestConfig(params: getGeocodingConfigsRequestConfigParams): JsonRestApiRequestConfig {
    return {
      restApiVersion: '3.25',
      httpMethod: 'GET',
      endpoint: `datasources/${params.datasourceLuid}/geocodingConfigs`,
      serverWideRequest: false,
    };
  }

export function addGeocodingConfigsRequestConfig(params: addUpdateGeocodingConfigsRequestConfigParams): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.25',
    httpMethod: 'PUT',
    endpoint: `datasources/${params.datasourceLuid}/geocodingConfigs`,
    serverWideRequest: false,
  };
}

export type GeocodingConfig = {
    id: string;
    name: string;
    targetColName: string;
    tokenLimit: number;
};

export type GeocodingConfigsResponse = {
  readonly geocodingConfigs: {
    readonly geocodingConfig: GeocodingConfig[];
  };
};

export type AddUpdateGeocodingConfigRequestBody = {
  readonly geocodingConfigId: string;
  readonly geocodingConfigName: string;
  readonly geocodingColName: string;
  readonly geocodingTokenLimit: number;
};

export function callGetConfigsViaApiService(params: getGeocodingConfigsRequestConfigParams) {
    return makeJsonRestApiRequest<void, GeocodingConfigsResponse>({
      config: getGeocodingConfigsRequestConfig(params),
      request: null,
    });
}

export function callAddUpdateConfigViaApiService(params: addUpdateGeocodingConfigsRequestConfigParams) {
return makeJsonRestApiRequest<AddUpdateGeocodingConfigRequestBody, void>({
    config: addGeocodingConfigsRequestConfig(params),
    request: { geocodingConfigId: params.configId, geocodingConfigName: params.configName, geocodingColName: params.colName, geocodingTokenLimit: params.tokenLimit },
});
}
